import { useFriends } from '../../contexts/FriendsContext';
import Friend from './Friend';

function FriendsList() {
  const { friends } = useFriends();

  return (
    <ul>
      {friends.map(friend => (
        <Friend key={friend.id} friend={friend} />
      ))}
    </ul>
  );
}

export default FriendsList;
